import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { cloneDeep } from 'lodash';

import { ModalService } from '@app/core/modal.service';
import { ModalResult, EditPasswordModalComponent as ModalComponent } from './edit-password-modal.component';

@Injectable({ providedIn: 'root' })
export class EditPasswordModalService {
  constructor(private modalService: ModalService) {}

  open(options?: NgbModalOptions) {
    const newOptions = cloneDeep(options || {});
    newOptions.windowClass = (newOptions.windowClass || '')
      .split(/\s+/)
      .concat('sidemodal-right')
      .join(' ');
    return this.modalService.open<ModalResult>(ModalComponent, null, newOptions);
  }
}
